import { RestUrl } from "../common/cyan.types";

export class FolderSharingUrl {
  public static getFolderSharings: RestUrl = ["GET", "/folder/sharings"];
  public static createFolderSharingsExternal: RestUrl = ["POST", "/folder/sharings/external"];
  public static removeFolderSharings: (id: bigint) => RestUrl = id => ["DELETE", `/folder/sharings/${id}`];
  public static upsertFolderSharings: RestUrl = ["POST", "/folder/sharings"];
}
